import { FC } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { setTrackingAdvertClick } from 'store/ui/uiSlice';

const BannerImage:FC = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:any = useAppSelector(selectQuiz);

  const handleClick = () => {
    dispatch(setTrackingAdvertClick());
  }

  if ( !quiz.advertImageEnabled || !quiz.advertImage ) return null;
  return (
    <div className="overflow-hidden flex-shrink-0">
      {quiz.advertUrl ? (
        <a className="block" href={quiz.advertUrl} target="_blank" rel="noreferrer" onClick={handleClick}>
          <img
            className="h-full w-full object-contain"
            src={quiz.advertImage}
            alt="banner"
          />
        </a>
      ) : (
        <img
          className="h-full w-full object-contain"
          src={quiz.advertImage}
          alt="banner"
        />
      )}
    </div>
  )
}

export default BannerImage;
